import { createSelector, createStructuredSelector } from 'reselect';
import {
  at,
  filter,
  flow,
  get,
  isObject,
  includes,
  trim,
  omitBy,
  toLower,
} from 'lodash/fp';

const isGroupedOptions = createSelector(
  (state, props) => props.options,
  flow(get([1, 'isGroup']), Boolean),
);

const getOptions = createSelector(
  ({ filterInputValue }) => filterInputValue,
  (state, { options }) => options,
  (filterInputValue, options) => {
    if (!filterInputValue) {
      return options;
    }

    filterInputValue = flow(trim, toLower)(filterInputValue);

    return filter(
      flow(
        at(['label', 'value']),
        omitBy(isObject),
        filter(flow(toLower, includes(filterInputValue))),
        get(['length']),
      ),
    )(options);
  },
);

const getModalTitle = createSelector(
  (state, { selectedOption }) => selectedOption,
  (state, { label }) => label,
  (state, { modalTitle }) => modalTitle,
  ({ isPlaceholder, label: selectedLabel }, label = '', modalTitle = '') => {
    if (modalTitle) {
      return modalTitle;
    }

    if (label && !isPlaceholder) {
      return `${label} - ${selectedLabel}`;
    }

    return label;
  },
);

export default createStructuredSelector({
  isGroupedOptions,
  modalTitle: getModalTitle,
  options: getOptions,
});
